import { Switch as NSwitch, type SwitchProps as Props } from '@heroui/react';
import { type Control, Controller, type FieldValues, type Path, type PathValue } from 'react-hook-form';
import { cn } from '../../cn';

export const Switch = (props: Props) => {
  return <NSwitch radius='sm' {...props} />;
};

export interface FormSwitchProps<T extends FieldValues>
  extends Omit<Props, 'value' | 'onChange' | 'isInvalid'> {
  name: Path<T>;
  control: Control<T, unknown>;
  defaultValue?: PathValue<T, Path<T>>;
}

export const FormSwitch = <T extends FieldValues>({
  control,
  name,
  classNames,
  className,
  defaultValue,
  ...rest
}: FormSwitchProps<T>) => {
  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error, invalid } }) => (
        <div className={cn('flex flex-col items-center space-y-2', className)}>
          <Switch
            {...rest}
            value={value}
            onChange={onChange}
            classNames={{
              base: cn(classNames?.base, invalid ? '!bg-danger border-danger' : ''),
              ...classNames,
            }}
            // isInvalid={invalid}
            // errorMessage={error?.message}
          />
          {invalid && <span className='text-sm'>{error?.message}</span>}
        </div>
      )}
    />
  );
};
